<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <!--<h1 class="headline mb-1">Asignación manual de plan</h1> -->
        <v-card class="mb-1">

          <v-card-title>
            <span class="title font-weight-light">Activar Plan</span>
          </v-card-title>

          <v-card-text>
            <v-form 
              ref="form" 
              v-model="valid" 
              lazy-validation>
              <!-- 
              <v-radio-group v-model="opcion" :mandatory="false">
                <v-radio label="Asignar Plan" value="plan"></v-radio>
                <v-radio label="Asignar Recarga" value="recarga"></v-radio>
              </v-radio-group>
            - -->
              <v-select
                single-line
                v-model="plan_id"
                :items="array_obj"
                item-text="nombre"
                item-value="id"
                :rules="[rules.required]"
                label="Selección de plan"
                prepend-icon="mdi-briefcase-plus-outline"
                :loading = "loading3" 
              ></v-select>
              <v-checkbox
                v-model="activacion"
                label="¿ Activar el plan ?"
              ></v-checkbox>
              <!--<v-select
                single-line
                v-if="opcion == 'recarga'"
                v-model="recarga_id"
                :items="recargas"
                item-text="descripcion"
                item-value="id"
                :rules="[rules.required]"
                label="Selección de Recarga"
                prepend-icon="mdi-briefcase-plus" 
              ></v-select>
            -->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn 
            :loading="loading || loading3"
            :disabled="!valid" 
            color="primary"  
            id="login" 
            class="mr-4" @click="validate" >Asignación</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>



      <v-col cols="12" md="6">
        <v-card class="mb-1">
          <v-card-title>
            <span class="title font-weight-light">Recargar plan activo</span>
          </v-card-title>
          <v-card-text>

            <v-form 
              ref="form2" 
              v-model="valid2" 
              lazy-validation>
              <v-select
                single-line
                @change="tipoPlan"
                v-model="plan_id2"
                :items="array_planes"
                item-text="nombre_plan"
                item-value="planId"
                :rules="[rules.required]"
                label="Selección de plan"
                prepend-icon="mdi-briefcase-plus-outline" 
              ></v-select>
              <v-select
                single-line
                v-model="recarga_id"
                :items="recargas_obj"
                item-text="descripcion"
                item-value="id"
                :rules="[rules.required]"
                label="Selección de recarga"
                prepend-icon="mdi-briefcase-plus" 
              ></v-select>
            </v-form>
          </v-card-text>


          <v-card-actions>
            <v-spacer />
            <v-btn 
            :loading="loading2"
            :disabled="!valid2" 
            color="primary"  
            id="login" 
            class="mr-4" @click="validate2" >Asignar recarga</v-btn>
          </v-card-actions>



        </v-card>
      </v-col>

    </v-row>
  </v-container>

</template>
<script>
    import axios from "axios";
    export default {  
    data: function() {
      return {
        valid: false,
        valid2: false,
        loading: false,
        loading2: false,
        loading3: false,
        plan_id: '',
        plan_id2: '',
        recarga_id: '',
        tipo_producto: '',
        activacion: true,
        justify: 'center',
        recargas_obj: [],
        array_planes: [],
        alignment: 'center',
        array_obj: [],
        rules: {
          required: value => !!value || 'Requerido',
          min: v => v.length >= 8 || 'Minimo 8 caracteres',
          emailMatch: () => ('The email and password you entered don\'t match'),
        },
      };
    },
    computed: {
    },
    mounted() {
      this.getPlanes();
      this.getPlanesAdquiridos();
    },
    methods: {
      getPlanes() {
        let getParametros = axios.get('Plan/listar', { 'headers': this.$store.state.user.headers });
        this.loading3 = true;
        return getParametros.then((callback) =>
        {
          this.array_obj = callback.data;
          this.loading3 = false;
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
          this.loading3 = false;
        });
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.loading = true;
          let postcarpeta = axios.post("OperacionManual/AsignarPlan",  {
            "producto_id": this.plan_id,
            "tipo_producto": "plan",
            "activar_producto" : this.activacion,
            "agrupador_id": this.$route.params.id,
          }, { 'headers': this.$store.state.user.headers })
          return postcarpeta.then((callback) => 
          {
            this.$refs.form.reset();
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Asignación completada exitosamente.' });
            this.loading = false;
          }).catch((error) => {
            //console.log(error.response.data);
            this.loading = false;
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'danger', text: error.response.data });
          });
        }
      },
      getPlanesAdquiridos() {
        let getPlanes = axios.post('Agrupador/listar_planes_adquiridos', { "Id": this.$route.params.id }, { 'headers': this.$store.state.user.headers });
        return getPlanes.then((callback) =>
        {
          console.log("PLANES ADQUIRIDOS: ",callback.data);
          this.array_planes = callback.data.filter(e => e.estado == 'ACTIVO');
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      tipoPlan(plan_id){
        console.log(plan_id);
        let recargas = this.array_obj.filter(v => v.id == plan_id)[0]
        console.log("RECARGAS: ",recargas);
        if(recargas.recargas.length == 0) {
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'danger', text: "Este plan no tiene recargas activas" });
        } else {
          this.recargas_obj = recargas.recargas;
        }
      },
      validate2() {
        if (this.$refs.form2.validate()) {
          this.loading2 = true;
          console.log("enviar data");
          let postcarpeta = axios.post("OperacionManual/AsignarPlan",  {
            "producto_id": this.recarga_id,
            "tipo_producto": "recarga",
            "activar_producto" : true,
            "agrupador_id": this.$route.params.id,
          }, { 'headers': this.$store.state.user.headers })
          return postcarpeta.then((callback) => 
          {
            this.$refs.form2.reset();
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Asignación completada exitosamente.' });
            this.loading2 = false;
          }).catch((error) => {
            console.log(error.response);
            this.loading2 = false;
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'danger', text: error.response });
          });
        }
      },


    },
  };
</script>